import React from 'react';
import Image from '../../../img/MainWebsite/AboutUs.png';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function AboutUs() {

  let navigate = useNavigate();

  return (
    <main >
      <Header />
      <div className={'mainContent whiteFont'}>
        <div className={'column'}>
          <h2 className={'green left'}>ABOUT US</h2>

          <h3 className={"green left"}>Built to Make Presentation Easier  </h3>
          <h5 className={'left'}>Vizo Menu was created to help businesses present what they offer more clearly, professionally, and conveniently.   </h5>
          <h5 className={'left'}> Most businesses already have great products, services, and experiences. The challenge is making sure customers can easily see,
            understand, and engage with those offerings at the right time.  </h5>
          <h5 className={'left'}> That is where Vizo Menu helps.  </h5>

          <h3 className={"green left"}>Your Business Stays Front and Center   </h3>
          <h5 className={'left'}> Vizo Menu is designed to support your brand, not compete with it.  </h5>
          <h5 className={'left'}> Customers access your offerings on their own phones or tablets, while the experience remains focused on your business, your
            presentation, and your customer relationship.  </h5>
          <h5 className={'left'}> Vizo Menu works quietly behind the scenes to make information easier to access, update, and understand.  </h5>

          <h3 className={"green left"}> Simple, Practical, and Flexible  </h3>
          <h5 className={'left'}> We believe technology should make business easier, not more complicated.  </h5>
          <h5 className={'left'}> Vizo Menu is built to supplement what businesses already do, while improving how information is presented to customers.  </h5>
          <h5 className={'left'}> The platform is simple to access, flexible to use, and designed to stay out of the way operationally.  </h5>

          <h3 className={"green left"}> Why We Built Vizo Menu  </h3>
          <h5 className={'left'}> We built Vizo Menu because presentation matters.  </h5>
          <h5 className={'left'}> When offerings are clearly displayed, customers feel more confident. Staff are better supported. Promotions are easier to feature.
            Updates are easier to manage. The overall experience becomes smoother.  </h5>
          <h5 className={'left'}>  Our goal is simple: help businesses turn better presentation into better engagement. </h5>

          <h3 className={"green left"}> Our Commitment  </h3>
          <h5 className={'left'}>Vizo Menu is committed to helping businesses improve presentation, support customer engagement, and create practical value without
            unnecessary complexity.   </h5>
          <h5 className={'left'}> Your brand remains the focus.  </h5>
          <h5 className={'left'}> Your offerings remain the priority.
          </h5>
          <h5 className={'left'}> Vizo Menu simply helps present them better.
          </h5>

        </div>
        <div className={'column'}>
          <img src={Image} className={'page-image image-border'} alt="Image 2" />
          <button className={' button-spacing chrome-background green-link'} onClick={() => { navigate("/Contact-Us") }}>
            CONTACT US TO SCHEDULE A DEMO
          </button>

        </div>
      </div>
      <Footer />
    </main>
  );
}

export default AboutUs;